'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M812.158 294.412c-87.050-122.21-78.88-35.914-163.208-279.684l-89.178-14.728-99.218 732.95c-223.632-127.958-364.672 3.468-328.984 168.886 18.92 87.712 161.432 170.274 301.8 88.78 66.342-39.89 87.672-104.22 96.14-149.838l70.876-543.852c252.89 222.974 172.142 357.892 119.85 513.244 107.498-44.334 275.88-239.888 91.922-515.758z' })
    ));
};